import withPage from '@lib/withPage';
import EmailInput from '@src/components/checkout/components/EmailInput/email-input';
import TextInput from '@src/components/checkout/components/TextInput/text-input';
import FeedbackModal from '@src/components/modals/FeedbackModal';
import Page from '@src/components/page';
import * as filterActions from '@src/redux/actions/filters';
import * as searchActions from '@src/redux/actions/search';
import axios from 'axios';
import React from 'react';
import { connect } from 'react-redux';
import Select from 'react-select';
import toast from 'react-hot-toast';
import SimpleReactValidator from 'simple-react-validator'; 
import { NextSeo } from 'next-seo';
import PhoneInput from '@src/components/checkout/components/PhoneInput/phone-input';

import * as types from '@src/redux/constants/actiontypes';
import { getCountries } from '@src/bigcommerce/api/checkout/get-checkout';


const businessTypesData = [
	{ value: '1', label: 'Car Battery Installer' } 
];

const categoriesInfo = {
	name: 'Categories:',
	id: -1,
};

 

class AddInstaller extends Page {
	constructor(props) {
		super(props);

		this.state = {
			firstName: '',
			lastName: '',
			email: '',
			phoneNumber: '',
			country: '',
			businessName: '',
		 	addressLine1: '',
			addressLine2: '',
			city: '',
			state: '',
			postalCode: '',
			loading: false,
			modalOpen: false,
		};

		this.validator = new SimpleReactValidator({
			autoForceUpdate: this,
			locale: 'en',
		});
	}

	   
	async componentDidMount() {
        await this.assignCountry();
    }


	async componentWillReceiveProps(nextProps) {
        if(nextProps.countries != this.props.countries){
			  await this.assignCountry();
 
        }
    }

	onOpenModal = () => {
		this.setState({ modalOpen: true });
	};

	onCloseModal = () => {
		this.setState({
			firstName: '',
			lastName: '',
			email: '',
			phoneNumber: '',
			businessName: '',
		 	addressLine1: '',
			addressLine2: '',
			city: '',
			state: '',
			postalCode: '',
			loading: false,
			modalOpen: false,
		});
	};

	submitForm = async () => {
		var payload = this.state;

		  
		var apiPath = 'https://api.marketring-api.com/v1/ProviderLocations/create/installer';
		
		
	 
		if (this.validator.allValid()) {
			//TODO: submit the form
			this.setState({ loading: true });
			console.log( apiPath,JSON.stringify(payload));
			var result = await axios
				.post(apiPath, payload, {
					crossdomain: true,
				})
				.then(response => {
					this.setState({ modalOpen: true });
					return response.data;
				})
				.catch(error => {
					console.log(error);
					this.setState({ loading : false });
					toast.error('Error Submitting Form - Please Try Again.');
					return error;
				});
			 
		} else {
			this.validator.showMessages();
			this.forceUpdate();
			return false;
		}
	};

	handleChange = evt => {
		const value = evt.target.value;

		this.setState({
			...this.state,
			[evt.target.name]: value,
		});
	};

	async assignCountry() {
	 	 

		var countrycheck = this.props.countries;
		 if (this.props.countries.length == 0) {
			
		////// HACK CAUSE ANNOYED
		 await getCountries()
			.then(response => {
				 

				countrycheck = response;
			 
			})
			.catch(error => {
				console.log(error);
			}); 
		} ;
		
		var result = countrycheck.find(({ country_iso2 }) => country_iso2 === this.state.country
			? this.state.country.country_iso2
			: this.props.geolocation.country
				? this.props.geolocation.country
				: 'US'
		);


		await this.setState({
			country: result
		}); 
		return ;
	}

	render() {
		const {
			firstName,
			lastName,
			email,
			phoneNumber,
			country,
			businessName, 
			addressLine1,
			addressLine2,
			city,
			state,
			postalCode,
			taxId,
			companyName
		} = this.state;

		return (
			<div className="page add-business add-installer">
				<NextSeo
					title={`Become an Installer | 1-800-Battery`}
					
				/>

				<FeedbackModal
					open={this.state.modalOpen}
					type="success"
					title="Success"
					content="Your Installer Account has been created. You will be receiving emails from payment providers such as Bill.com and a download link for our driver application.  Welcome aboard."
					onCloseModal={this.onCloseModal}
					buttonConfirm={'OK'}
				/>
				<div className="container">
					<div className="row">
						<div className="col-lg-6 offset-lg-3">
							<div className="business-registration-form">
								<h1>Become an Installer</h1>

								<div className="intro">
									<p>
										Complete and submit the form below.  
									</p>

									<p>
										Please only submit this form if you can officially represent the business or yourself.
									</p>
								</div>

								<div className="form">
									<div className="group">
										<h3>Contact Information</h3>
										<small>*Required Fields</small>

										<div className="row mt-3">
											<div className="col-12 col-sm-6">
												<TextInput
													label={'First Name*'}
													value={firstName}
													placeholder="First Name"
													name="firstName"
													onChange={this.handleChange}
												/>

												<div className="validator-message-container">
													{this.validator.message('First Name', firstName, 'required')}
												</div>
											</div>

											<div className="col-12 col-sm-6">
												<TextInput
													label={'Last Name'}
													value={lastName}
													placeholder="Last Name*"
													name="lastName"
													onChange={this.handleChange}
												/>

												<div className="validator-message-container">
													{this.validator.message('Last Name', lastName, 'required')}
												</div>
											</div>
										</div>

										<div className="row mt-3">
											<div className="col-12 col-sm-6">
												<TextInput
													label={'company'}
													value={businessName}
													placeholder="Company"
													name="businessName"
													onChange={this.handleChange}
												/>

												 
											</div>

											<div className="col col-sm-6">
											<PhoneInput
												validationError={this.validator.message(
													'phone',
													this.state.phoneNumber,
													'required|phone'
												)}
												id={`${this.props.name}Phone`}
												label={'Phone'}
												labelAfterInput={true}
												value={this.state.phoneNumber}
												placeholder={'Phone Number'}
												onChange={phone => this.setState({ phoneNumber: phone })} 
											/>
												 

												<div className="validator-message-container">
													{this.validator.message('Phone', phoneNumber, 'required')}
												</div>
											</div>
										</div>
										<div className="row mt-3">
											<div className="col-12">
												<EmailInput
													placeholder={'Email*'}
													type="email"
													name="email"
													value={email}
													onChange={this.handleChange}
												/>

												<div className="validator-message-container">
													{this.validator.message('Email', email, 'required|email')}
												</div>

												
											</div>
										 
										</div>
									</div>

									<div className="group mb-0">
										<h3>Address Information</h3>
										<small>*Required Fields</small>

										<div className="mt-3">
											<Select
												value={this.state.country}
												options={this.props.countries}
												placeholder="Country"
												getOptionLabel={({ country }) => country}
												getOptionValue={({ country_iso2 }) => country_iso2}
												onChange={value => this.setState({ country: value, state: '' })}
												isClearable={false}
												isSearchable={false}
											/>

											<div className="validator-message-container">
												{this.validator.message('Country', country, 'required')}
											</div>
										</div>

										<div className="mt-3">
											 
										 
 
											<TextInput
												label={'Address Line 1'}
												value={addressLine1}
												placeholder="Address Line 1*"
												name="addressLine1"
												onChange={this.handleChange}
											/>

											<div className="validator-message-container">
												{this.validator.message('Address Line 1', addressLine1, 'required')}
											</div>

										</div>

										<div className="mt-3">
											 		 
 
											<TextInput
												label={'Address Line 2'}
												value={addressLine2}
												placeholder="Address Line 2"
												name="addressLine2"
												onChange={this.handleChange}
											/>
 

										</div>
										 
											  
										
										 
										
											<div className="row mt-3">
											 
										 
											<div className="col-6 col-sm">
												<TextInput
													label={'City'}
													value={city}
													placeholder="City*"
													name="city"
													onChange={this.handleChange}
												/>

												<div className="validator-message-container">
													{this.validator.message('City', city, 'required')}
												</div>
											</div>

											<div className="col-6 col-sm">
												<Select
													getOptionLabel={({ state_abbreviation }) => state_abbreviation}
													getOptionValue={({ state_abbrevation }) => state_abbrevation}
													options={this.state.country ? this.state.country.states : []}
													placeholder="State"
													onChange={value => this.setState({ state: value })}
													isClearable={false}
												isSearchable={false}
												/>

												<div className="validator-message-container">
													{this.validator.message('State', state, 'required')}
												</div>
											</div>

											<div className="col-12 col-sm">
												<TextInput
													label={'Postal Code'}
													value={postalCode}
													placeholder="Postal Code*"
													name="postalCode"
													onChange={this.handleChange}
												/>

												<div className="validator-message-container">
													{this.validator.message('Postal Code', postalCode, 'required')}
												</div>
											</div>
										</div>

										<div className="mt-3 text-right">
											<button
												className="btn"
												disabled={this.state.loading}
												onClick={() => this.submitForm()}>
												{this.state.loading && (
													<span>
														<i className="fas fa-circle-notch fa-spin"></i> Processing...
													</span>
												)}
												{!this.state.loading && <span>Submit</span>}
											</button>
										</div>
										</div>
									</div>
								
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	}
}

const mapDispatchToProps = dispatch => ({
	setSearchValue: payload => dispatch(searchActions.setSearchValue(payload)), // TODO: Change to Set GeoLocation Based on Map Selection.... ?  Need to Determine How...
	setFilterValue: payload => dispatch(filterActions.setFilterValue(payload)),
	setCountries: data => dispatch(types.RECEIVE_COUNTRIES)
  
});

const mapStateToProps = state => ({
	categories: state.categories.allCategories,
	brands: state.brands.brands,
	countries: state.countries.countries,
	geolocation: state.geolocation,
});
 

export default withPage(connect(mapStateToProps, mapDispatchToProps)(AddInstaller));
